import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_MY_SCOPE_TYPES } from '../gql/auth';

const useHasScopeType = (expextedScopeType) => {
  const { data, loading } = useQuery(GET_MY_SCOPE_TYPES, {
    // fetchPolicy: 'cache-and-network',
  });
  const [result, setResult] = useState({
    loading: true,
    hasScopeType: false,
  });

  useEffect(() => {
    !loading
      ? setResult({
          hasScopeType: data.myScopeTypes.indexOf(expextedScopeType) >= 0,
          loading: false,
        })
      : setResult({
          loading: true,
          hasScopeType: false,
        });
  }, [loading, data, expextedScopeType]);

  return result;
};

export default useHasScopeType;
